export const POLLING_INTERVAL = 500;
// TODO: Revisit timeout functionality
export const STREAMING_CHECK_DELAY = 15000;
export const MAX_RETRIES = 3;
export const RESPONSE_TIMEOUT_MS = 90000;
export const GUARDRAIL_REJECTION_MESSAGE = "Sorry, Ask TeamForm cannot respond";

export const SOURCE_TYPES = {
  chat_q_and_a: "chat_q_and_a",
  team_summary: "team_summary",
  forecast_summary: "forecast_summary",
};

export const AGENTCORE_NAMES = {
  ASK_TEAMFORM: "ask_teamform",
  ASK_TEAMFORM_V2: "ask_teamform_v2",
  GQL_EXPERT_V2: "graphql_expert_v2",
  SUMMARIES: "summaries",
};

export const ASK_TEAMFORM_HELP_HOST = "get.help.teamform.co";

/**
 * Help (support) mode ships in the v2 agent only.
 * @param {string} agent
 */
export const isAskTeamformV2Agent = (agent) =>
  agent === AGENTCORE_NAMES.ASK_TEAMFORM_V2;

/** @param {string} url */
export const isAllowedHelpSourceUrl = (url) => {
  if (typeof url !== "string" || !url) {
    return false;
  }

  try {
    const parsed = new URL(url);
    return (
      parsed.hostname === ASK_TEAMFORM_HELP_HOST &&
      (parsed.protocol === "https:" || parsed.protocol === "http:")
    );
  } catch {
    return false;
  }
};

/** Ask TeamForm chat modes (sent as askTeamformMode when enableSupportQuestionInAskTeamform is on). */
export const ASK_TEAMFORM_MODES = {
  DATA: "data",
  SUPPORT: "support",
};

/** UI copy for each mode — API values stay data/support. */
export const ASK_TEAMFORM_MODE_UI = {
  [ASK_TEAMFORM_MODES.DATA]: {
    label: "Workspace",
    hint: "Live data from your org",
    prompt: "Ask about people, teams, or objectives…",
    welcomeTitle: "What would you like to know about your org?",
    icon: ["far", "sitemap"],
  },
  [ASK_TEAMFORM_MODES.SUPPORT]: {
    label: "Help",
    hint: "Guides and how-to articles",
    prompt: "Ask about imports, setup, or configuration…",
    welcomeTitle: "What can we help you with?",
    icon: ["far", "question-circle"],
  },
};

export const AI_BRAND_GRADIENT =
  "linear-gradient(135deg, #0091ea 0%, #9b51e0 100%)";

export const DASHBOARD_REGEX =
  /\|dashboard([^|]*)\|\s*<\/p>\s*(.*?)(?:\|dashboard\||$)/gs;

export const DASHBOARD_REGEX_V2 =
  /<dashboard([^>]*)>((?!<\/dashboard>).+)(<\/dashboard>)/gs;

export const GRAPH_REGEX = /<graph([^>]*)>((?!<\/graph>).+)(<\/graph>)/gs;
export const E_CHART_REGEX =
  /(?:<|&lt;)e-chart\b(?![\s\S]*(?:<\/e-chart>|&lt;\/e-chart&gt;))[\s\S]*$/gs;
